// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Decco = require("decco/src/Decco.bs.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ArrayUtils$SmartcutsMacros = require("../../../../bs-utils/src/ArrayUtils.bs.js");
var ReactUtils$SmartcutsMacros = require("../../../../bs-utils/src/ReactUtils.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "altKey",
                Decco.boolToJson(v.altKey)
              ],
              [
                "ctrlKey",
                Decco.boolToJson(v.ctrlKey)
              ],
              [
                "metaKey",
                Decco.boolToJson(v.metaKey)
              ],
              [
                "shiftKey",
                Decco.boolToJson(v.shiftKey)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var altKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "altKey"), null));
  if (altKey.TAG === /* Ok */0) {
    var ctrlKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ctrlKey"), null));
    if (ctrlKey.TAG === /* Ok */0) {
      var metaKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "metaKey"), null));
      if (metaKey.TAG === /* Ok */0) {
        var shiftKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "shiftKey"), null));
        if (shiftKey.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    altKey: altKey._0,
                    ctrlKey: ctrlKey._0,
                    metaKey: metaKey._0,
                    shiftKey: shiftKey._0
                  }
                };
        }
        var e = shiftKey._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".shiftKey" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = metaKey._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".metaKey" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = ctrlKey._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".ctrlKey" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = altKey._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".altKey" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function stringify(modifierKeys) {
  return $$Array.map((function (param) {
                  return param[1];
                }), Belt_Array.keep([
                    [
                      modifierKeys.altKey,
                      "Alt"
                    ],
                    [
                      modifierKeys.ctrlKey,
                      "Ctrl"
                    ],
                    [
                      modifierKeys.metaKey,
                      "Meta"
                    ],
                    [
                      modifierKeys.shiftKey,
                      "Shift"
                    ]
                  ], (function (param) {
                      return param[0];
                    }))).join("+");
}

function toInt(modifierKeys) {
  return Belt_List.reduceWithIndex({
              hd: modifierKeys.altKey,
              tl: {
                hd: modifierKeys.ctrlKey,
                tl: {
                  hd: modifierKeys.metaKey,
                  tl: {
                    hd: modifierKeys.shiftKey,
                    tl: /* [] */0
                  }
                }
              }
            }, 0, (function (bits, isPressed, index) {
                return bits + (
                        isPressed ? (1 << index) : 0
                      ) | 0;
              }));
}

function areAnyPressed(param) {
  if (param.altKey || param.ctrlKey || param.metaKey) {
    return true;
  } else {
    return param.shiftKey;
  }
}

function reactify(classNameOpt, modifierKeys) {
  var className = classNameOpt !== undefined ? classNameOpt : "modifierKey";
  return ReactUtils$SmartcutsMacros.joinWith_(" + ", ArrayUtils$SmartcutsMacros.filterMap((function (param) {
                    if (!param[0]) {
                      return ;
                    }
                    var keyString = param[1];
                    return Caml_option.some(React.createElement("kbd", {
                                    key: "kbd-" + keyString,
                                    className: className
                                  }, keyString));
                  }), [
                  [
                    modifierKeys.altKey,
                    "Alt"
                  ],
                  [
                    modifierKeys.ctrlKey,
                    "Ctrl"
                  ],
                  [
                    modifierKeys.metaKey,
                    "⌘"
                  ],
                  [
                    modifierKeys.shiftKey,
                    "Shift"
                  ]
                ]));
}

var noKeyPressed = 0;

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.noKeyPressed = noKeyPressed;
exports.toInt = toInt;
exports.areAnyPressed = areAnyPressed;
exports.reactify = reactify;
/* react Not a pure module */
